module.exports = __webpack_public_path__ + "static/img/drag-and-drop.94420aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/drag-and-drop.png
// module id = 3atk
// module chunks = 1